import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import reportWebVitals from './reportWebVitals';

// HAPPY HIPPOS BIR DETAILS
window.company_name = "Riverside Indonesian Bbq Corp.";
window.company_address = "Unit 204 One Paseo Cebu Bldg Paseo Saturnino Maria Luisa Road Banilad City of Cebu Cebu";
window.company_vat_reg_tin = "VAT Reg TIN: 656957788-000";
window.company_min = "MIN: 24111816313412970";
window.company_sn = "SN: JXHKWNTKY9";
window.company_ptu_no = "PTU No: FP112024-081-0483967-00000";
window.issued_date = "Issue Date: 01/27/2025";

// MYT BIR DETAILS
window.myt_name = "MYT SoftDev Solutions, Inc.";
window.myt_address1 = "301 The Greenery, Pope John Paul II Avenue, Kasambagan";
window.myt_address2 = "Cebu City, Cebu";
window.myt_vat_reg_tin = "VAT Reg TIN: 497280919-000";
window.myt_acc_no = "Acc No: 0814972809192023071833";
window.myt_issued_date = "Issue Date: 08/14/2023 ";
// window.websocket_ip = 'ws://192.168.1.25:3000';
// window.websocket_ip = 'ws://192.168.0.168:3000';

// window.printer_name = "EPSON TM-T82X Receipt";
window.printer_name = "CASHIER";

window.socket_ip = "ws://192.168.1.10:3000";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
